import React from "react";
import { Link } from "react-router-dom";

import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

import MSFAvatar from "../MSFAvatar";
import AlertMessage from "../../../Common/Alert/AlertMessage";
import { questionnaireStatusMessage } from "./QuestionnaireFunctions";
import QuestionnaireDetails from "./QuestionnaireDetails";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

function QuestionnaireButton({ id, status }) {
    let label = "View";
    let color = "neutral";
    let textColor = "rgba(0,0,0,0.7)";

    switch (status) {
        case "open":
            label = "Complete";
            color = "primary";
            textColor = "rgb(255.255.255)";
            break;

        default:
            break;
    }

    return (
        <Button
            variant={"contained"}
            color={color}
            disableElevation={true}
            aria-label="Questionnaire"
            component={Link}
            to={`/msf/questionnaires/${Number(id) || ""}`}
            endIcon={<KeyboardArrowRightOutlinedIcon />}
        >
            <Typography variant={"span"} sx={{ color: textColor }}>
                {label}
            </Typography>
        </Button>
    );
}

function QuestionnaireListItem(props) {
    const questionnaire = props.data;

    const title = questionnaire?.title
        ? questionnaire.title
        : questionnaire.resourceType;

    const avatarBadge =
        questionnaire?.status === "closed" ? "checked" : "warning";
    const type = questionnaire?.type?.name || "Not specified";
    const alert = questionnaireStatusMessage(
        questionnaire.status,
        questionnaire.endDate
    );

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                avatar={<MSFAvatar type="questionnaire" badge={avatarBadge} />}
                title={
                    <Typography component="h2" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {type}
                    </Typography>
                }
                action={
                    <Stack
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={2}
                        sx={{ padding: "8px" }}
                    >
                        <QuestionnaireButton
                            id={questionnaire?.uuid}
                            status={questionnaire?.status}
                        />
                    </Stack>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <QuestionnaireDetails
                        requester={questionnaire?.requester}
                        areaOfWork={questionnaire?.areaOfWork}
                        organisation={questionnaire?.organisation}
                        startDate={questionnaire?.startDate}
                        endDate={questionnaire?.endDate}
                    />
                </Box>
            </CardContent>
            <CardContent>
                <Box className="card-content">
                    <AlertMessage
                        severity={alert.severity}
                        message={alert.message}
                    />
                </Box>
            </CardContent>
        </Card>
    );
}

export default QuestionnaireListItem;
